import React from "react";
import { Card } from "react-bootstrap";
import { t } from "i18next";
import defaultBadge from "../../assests/images/silver-medal.png";

export default function QuizComplete({ quizComplete, data }) {
  const { testPassed, badgeGained, certficateGained, totalQuestions, totalQuestionsPassed } = quizComplete;
  const noQuestions = data?.questions?.length === 0;

  const renderResultMessage = () => {
    if (noQuestions && testPassed) {
      return (
        <>
          {t("qualified")}{" "}
          <i className="fa-solid fa-circle-check fa-lg" style={{ color: "#36da16" }}></i>
        </>
      );
    }

    return testPassed ? (
      <>
        {t("passed")}{" "}
        <i className="fa-solid fa-circle-check fa-lg" style={{ color: "#36da16" }}></i>
      </>
    ) : (
      <>
        {t("failed")}{" "}
        <i className="fa-solid fa-circle-xmark fa-lg" style={{ color: "#e61919" }}></i>
      </>
    );
  };

  const renderScore = () => {
    if (!noQuestions) {
      return (
        <div>{`Your score is ${totalQuestionsPassed} out of ${totalQuestions}`}</div>
      );
    }
    return null;
  };

  const renderBadge = () => {
    if (!badgeGained) return null;

    return (
      <>
        <hr />
        <div style={{ width: "100%", textAlign: "center", position: "relative", marginBottom: "10px" }}>
          <div>Badges Gained</div>
          <img
            src={badgeGained.image || defaultBadge}
            alt="badge"
            style={{ width: "10rem", padding: "10px" }}
          />
          <br />
          <span>{badgeGained.name}</span>
        </div>
      </>
    );
  };

  const renderCertificate = () => {
    if (!certficateGained) return null;

    return (
      <>
        <hr />
        <div>
          +1 Course Certificate{" "}
          <i className="fa-solid fa-circle-check fa-lg" style={{ color: "#36da16" }}></i>
        </div>
      </>
    );
  };

  return (
    <div className="quiz-answer-preview">
      <Card style={{ border: "none" }}>
        <Card.Body className={`quiz-result-view ${testPassed ? "quiz-result-view-pass" : "quiz-result-view-fail"}`}>
          <div>{renderResultMessage()}</div>
          {renderScore()}
        </Card.Body>

        {renderBadge()}
        {renderCertificate()}
      </Card>
    </div>
  );
}
